import { MetricStats, MetricValue } from '~/pages/reports/shared/types'
import { unitMap } from '~/pages/reports/shared/utils/unit'

export const getUnit = (metric: MetricStats, value: MetricValue) => {
  const unit = unitMap[metric.unit]
  const valueUnit = value.unit && unitMap[value.unit]
  return valueUnit || unit || 'none'
}
